<template lang="html">
  <table :style='styles.tableStyle'>
    <tr v-for='(record, key) in displayData' :style='styles.trStyle'>
      <td v-if="record && record.arrow_for_close" class='relative text-center'>
        <span>{{record.value}}</span>
        <i :style="{'float': 'right', 'margin-right': '0.5rem', 'cursor': 'pointer'}" class="fa fa-times" aria-hidden="true" @click='removeItem(record)'></i>
      </td>

      <td v-else-if="record && (record.isEditable && displayData.selfOffer) || (record.editable && record.clickAway)" class='relative text-center'>
        <input
          type="text"
          :style='styles.editBoxWidthFull'
          v-model='record.value'
          @blur.stop='editRecord(record, displayData.itemId)'
          @keyup.enter.stop='editRecord(record, displayData.itemId)'>
        <i class='fa fa-pencil edit-marker'></i>
      </td>

      <td v-else-if="record && record.editable" class='relative text-center'>
        <input type="text" :style='styles.editBoxWidthFull' v-model='record.value' v-on:keyup='processData(record)'>
        <i class='fa fa-pencil edit-marker'></i>
      </td>

      <td
        v-else-if="(record && record.hasOwnProperty('makeLink') && record.makeLink) && record.hasOwnProperty('type') && record.type"
        :style='(key === 0 && styles.topHeaderStyle) ? styles.topHeaderStyle : styles.tdStyle'
        @click='processRecord(record)'>

        <a :style='styles.aActualStyle'>{{ record.value }}</a>
      </td>

      <td
        v-else-if="record && record.hasOwnProperty('makeLink') && record.makeLink"
        :style='(key === 0 && styles.topHeaderStyle) ? styles.topHeaderStyle : styles.tdStyle'
        @click='processRecord(record)'>
        <div class='relative' @mouseover='showPopOver(key)' @mouseout='hidePopOver(key)'>
          <div :class="{'hover-detail': key === showPopKey, 'hide': key !== showPopKey}">
            {{ record.value }}
          </div>
          <div class="null-height">
            <a :style='styles.aStyle'>{{ addDotsToData(record.value) }}</a>
          </div>
        </div>
      </td>

      <td v-else-if="pendingOrPast === 'PAST'" :style='styles.actualStyle'>
        {{ (record && typeof record.value !== "undefined" && record.value !== null) ? record.value : (typeof record !== "undefined" && record !== null && record.toString().length > 0) ? record : "&nbsp;" }}
      </td>

      <td v-else-if="pendingOrPast === 'PENDING'" :style='styles.estimatedStyle'>
        {{ (record && typeof record.value !== "undefined" && record.value !== null) ? record.value : (typeof record !== "undefined" && record !== null && record.toString().length > 0) ? record : "&nbsp;" }}
      </td>

      <td v-else :style='(key === 0 && styles.topHeaderStyle) ? styles.topHeaderStyle : styles.tdStyle'>
        <template v-if='record && record.length > 40'>
          <div>
            <div class='relative' @mouseover='showPopOver(key)' @mouseout='hidePopOver(key)'>
              <div :class="{'hover-detail': key === showPopKey, 'hide': key !== showPopKey}">
                {{ record }}
              </div>
              <div class="null-height">
                {{ addDotsToData(record) }}
              </div>
            </div>
          </div>
        </template>
        <template v-else-if='record && record.value && record.value.length > 40'>
          <div class='relative' @mouseover='showPopOver(key)' @mouseout='hidePopOver(key)'>
            <div :class="{'hover-detail': key === showPopKey, 'hide': key !== showPopKey}">
              {{ record.value }}
            </div>
            <div class="null-height">
              {{ addDotsToData(record.value) }}
            </div>
          </div>
        </template>
        <template v-else>
          <template v-for="value in getCellRecord(record)">
            <span :class="{'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'}">
              {{ value }}
            </span>
          </template>
        </template>
      </td>
    </tr>
  </table>
</template>

<script>
import { dotty } from 'src/Services/stringLengthPadding'

export default {
  props: {
    'data': {
      required: true
    },
    'styles': {
      required: true
    },
    'type': {
      required: false
    },
    'handleEvent': {
      required: false
    },
    'stringPadding': {
      required: false,
      type: Object,
      default: null
    },
    'functions': {
      required: false
    },
    'pendingOrPast': {
      required: false
    }
  },
  data () {
    return {
      lastTypeValue: null,
      showPopKey: null
    }
  },
  computed: {
    displayData () {
      // return (this.stringPadding) ? this.addDotsToData(this.data) : this.data
      return this.data
    }
  },
  methods: {
    showPopOver (key) {
      this.showPopKey = key
    },
    hidePopOver (key) {
      this.showPopKey = null
    },
    removeItem (record) {
      record.event = 'CLOSE_EVENT'
      this.handleEvent(record)
    },
    getCellRecord (record) {
      record = (record && typeof record.value !== 'undefined' && record.value !== null) ? record.value : (typeof record !== 'undefined' && record !== null && record.toString().length > 0) ? record : '\xa0'
      record = record.toString()

      let splittedArray = record.split(' ')
      let arrayResult = []
      for (let i = 0; i < splittedArray.length; i++) {
        let text = splittedArray[i]
        if (text.includes('-')) {
          let indexOfMinus = text.indexOf('-')
          let part1 = text.substring(0, indexOfMinus)
          if (part1) {
            arrayResult.push(part1)
          }
          let part2 = text.substring(indexOfMinus, text.length)
          if (part2) {
            let part2Index = part2.indexOf(')')
            let first = part2.substring(0, part2Index)
            if (first) {
              arrayResult.push(first)
            }
            let second = part2.substring(part2Index, part2.length)
            if (second) {
              arrayResult.push(second)
            }
          } else {
            arrayResult.push(part2)
          }
        } else {
          arrayResult.push(text)
        }
      }
      return arrayResult
    },
    processRecord (record) {
      if (this.type && this.type === 'record') {
        this.handleEvent(record)
      }
    },
    editRecord (record, id) {
      let fn = this.functions
      fn(record, id)
    },
    addDotsToData (data) {
      if (!this.stringPadding) return data
      let padLength = this.stringPadding.length
      if (typeof data === 'string') {
        return dotty(data, padLength)
      }
      data.forEach((e, i, ctx) => {
        if (typeof e.value !== 'undefined') {
          data[i].value = dotty(data[i].value, padLength)
        } else {
          data[i] = dotty(data[i], padLength)
        }
      })
      return data
    },
    processData (record) {
      // if (this.lastTypeValue !== record.value) {
      //   this.lastTypeValue = record.value
      //   this.handleEvent(record)
      // }
      this.handleEvent(record)
    }
  }
}
</script>

<style lang="css" scoped>
  .null-height {
    /*height: 0;*/
  }
  .hover-detail {
    position: absolute;
    height: auto;
    top: 2rem;
    left: 0rem;
    padding: 0.5rem 1rem;
    background: white;
    border-radius: .3rem;
    border: .1rem solid rgb(16,140,137);
    opacity: 1;
    z-index: 100;
    transition: opacity .5s ease-out;
  }
  .hide {
    position: absolute;
    height: 0;
    opacity: 0;
  }
  .show
  .overflowX {
    overflow: hidden;
  }
  .fa-times:hover {
    color: #a6a6a6;
  }
  .margin-left {
    margin-left: -4px
  }
  .margin-right {
    margin-right: -4px
  }
  .invisible {
    color: transparent;
  }
  .edit-marker {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1rem;
  }
  .relative {
    position: relative;
  }
  .text-center {
    text-align: center;
  }
  td input {
    padding: 0;
    outline: none;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?29cf8d7c